'use client';

import { useEffect } from 'react';
import { useInteractiveLoader } from './PartnerLoader';

export const TopBarLoadingFallback = () => {
  const { startLoader, completeProgressBar } = useInteractiveLoader();

  useEffect(() => {
    startLoader();
    return () => completeProgressBar();
  }, [startLoader, completeProgressBar]);

  return <div className="h-screen" />;
};
